import { put, select } from 'redux-saga/effects';
import { betMessages } from 'constants/toastMessages';
import {
  clearAllBetsAction,
  updatePlacedBetsAction,
  setConfirmedBetAction,
} from 'core/widgets/Bet/actions';
import { IConfirmedBet } from 'core/widgets/Bet/types';
import { EMPTY_BET } from 'core/widgets/Bet/data';
import { fillAllSlots } from 'core/widgets/Bet/utils';
import { IRoundState, RoundStates } from 'core/widgets/RoundStates/types';
import { roundStateSelector } from 'core/widgets/RoundStates';
import { addToastAction } from 'core/widgets/Toast/actions';
import { setTotalBetAction } from 'core/widgets/User/actions';
import { Notifications } from 'types';
import { ToastTypes } from 'types/toast';
import { OnPendingBetsMadeData } from '../types';

export function* onPendingBetsMadeSaga({
  type: notificationType,
  data: result,
}: OnPendingBetsMadeData) {
  if (notificationType === Notifications.PENDING_BETS_MADE) {
    if (result.accepted) {
      const roundState: IRoundState['roundState'] = yield select(roundStateSelector);
      if (roundState === RoundStates.RoundCanceled) {
        return;
      }

      const confirmedPendingBet: IConfirmedBet[] = fillAllSlots(result.bets);

      yield put(
        updatePlacedBetsAction({
          present: EMPTY_BET,
          past: [],
        }),
      );

      yield put(setTotalBetAction(result.total));
      yield put(setConfirmedBetAction(confirmedPendingBet));
      yield put(addToastAction({ type: ToastTypes.SUCCESS, value: betMessages.ACCEPTED }));
    }

    if (!result.accepted) {
      yield put(clearAllBetsAction());
    }
  }
}
